var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"copyright"},[_vm._v("\n                "+_vm._s(_vm.currentVersion)+"\n                "),_c('div',{staticClass:"mt-2"},[_c('b-img',{staticClass:"logo",attrs:{"fluid":"","src":"/img/sefos.png","alt":""}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }